module.exports = __webpack_public_path__ + "static/media/due-diligence-hero.1a148e4e.jpg";